import { render } from "./ProductoImagenes.vue?vue&type=template&id=51ed4fc6"
import script from "./ProductoImagenes.vue?vue&type=script&lang=js"
export * from "./ProductoImagenes.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\framacion_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__